import COM from './IsVisible'

export default COM
